(function () {
    'use strict';

    angular
        .module('app')
        .controller('EntityTemplateEditCtrl', EntityTemplateEditCtrl);

    EntityTemplateEditCtrl.$inject = [
        '$location',
        '$scope',
        '$routeParams',
        '$q',
        'EntityTemplatesService',
        'UnsavedChangesService',
        'EntitiesService',
        'FieldTypesService',
        'LastUpdatedService',
        'NavigationAidService',
        'DialogService',
        'FieldSelectorService',
        'ChilliUserProfileService',
        'SystemService',
        'ObjectSaveErrorHandlerService',
        'WindowTitleService'];

    function EntityTemplateEditCtrl(
        $location,
        $scope,
        $routeParams,
        $q,
        EntityTemplatesService,
        UnsavedChangesService,
        EntitiesService,
        FieldTypesService,
        LastUpdatedService,
        NavigationAidService,
        DialogService,
        FieldSelectorService,
        ChilliUserProfileService,
        SystemService,
        ObjectSaveErrorHandlerService,
        WindowTitleService) {

        /* jshint validthis:true */
        var vm = this;
        vm.entityFieldMode = 'edit';
        vm.entityTemplate = newEntityTemplate();
        vm.addField = addField;
        vm.addSearchField = addSearchField;
        vm.removeSearchField = removeSearchField;
        vm.editField = editField;
        vm.deleteField = deleteField;
        vm.addOrderOption = addOrderOption;
        vm.editOrderOption = editOrderOption;
        vm.deleteOrderOption = deleteOrderOption;
        vm.setOrderOptionDefault = setOrderOptionDefault;
        vm.saveEntityTemplate = saveEntityTemplate;
        vm.deleteEntityTemplate = deleteEntityTemplate;
        vm.unsavedChanges = UnsavedChangesService;
        vm.showTab = showTab;
        vm.copyEntityTemplate = copyEntityTemplate;
        vm.viewEntities = viewEntities;
        vm.loadDefaultEntityFields = loadDefaultEntityFields;
        vm.showUsage = showUsage;
        vm.close = close;
        vm.usersList = [];
        vm.availableFields = { Search: [] };
        vm.documentTemplateListConfiguration = { EntityTemplateId: $routeParams.id };
        vm.emailTemplateListConfiguration = { EntityTemplateId: $routeParams.id };
        vm.smsTemplateListConfiguration = { EntityTemplateId: $routeParams.id };
        vm.loading = true;
        vm.notFound = false;
        vm.permissionDenied = false;
        vm.currentTabPage = 'details';
        vm.entityTemplateNameBlur = entityTemplateNameBlur;
        Object.defineProperty(vm, 'entityTemplateIsNew', {
            get: function () { return !($routeParams.id && $routeParams.id !== 'new'); }
        });
        vm.viewTitle = 'Entity Template';
        Object.defineProperty(vm, 'securityDefersToAdmin', { get: getSecurityDefersToAdmin });
        Object.defineProperty(vm, 'dirty', {
            get: function () { return !_.isNil(UnsavedChangesService) && UnsavedChangesService.dirty; }
        });
        Object.defineProperty(vm, 'lastUpdatedLabel', {
            get: function () { return LastUpdatedService.getLabel(vm.entityTemplate); }
        });

        // Handles the ng sortable list for entity fields. Only items originating from this ng sortable list should be droppable onto this list.
        $scope.entityFieldDragListener = {
            accept: function (sourceItemHandleScope, destSortableScope) {
                return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
            }
        };

        // Handles the ng sortable list for order options. Only items originating from this ng sortable list should be droppable onto this list.
        $scope.orderOptionDragListener = {
            accept: function (sourceItemHandleScope, destSortableScope) {
                return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
            }
        };

        // Handles the ng sortable lists for entity search fields. Only items originating from these ng sortable lists should be droppable onto these lists.
        $scope.entitySearchFieldDragListener = {
            accept: function (sourceItemHandleScope, destSortableScope) {
                return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
            }
        };

        activate();

        function activate() {
            updateViewTitle();

            NavigationAidService.watchTabPage($scope, 'vm.currentTabPage');

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadEverything,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () {
                    vm.loading = false;

                    // Create an empty entity model and file attachment list for the preview tab
                    vm.entity = { Fields: [], EntityTemplate: vm.entityTemplate };
                    vm.fileAttachmentList = [];
                    loadDefaultEntityFields();

                    var currentTabFromHistory = NavigationAidService.getCurrentTabPage();
                    if (!_.isNil(currentTabFromHistory)) {
                        // Load tab page from history
                        if (vm.showTab(currentTabFromHistory)) {
                            vm.currentTabPage = currentTabFromHistory;
                        }
                    }
                }
            });

            function loadEverything() {
                var loadPromises = [];
                loadPromises.push(loadUsers());
                loadPromises.push(loadEntityTemplate());
                loadPromises.push(loadEntityTemplates());
                loadPromises.push(loadFieldTypes());

                $q.all(loadPromises).finally(function () {
                    updateViewTitle();
                });

                return $q.all(loadPromises);
            }
        }


        function loadUsers() {
            return EntitiesService.getUserSummary().then(
                function ok(data) {
                    vm.usersList = data;
                },
                function error(response) {
                    DialogService.error('Error fetching User list', response);
                });
        }

        function loadEntityTemplate() {
            var loadEntityTemplatePromise;

            if (!vm.entityTemplateIsNew) {
                loadEntityTemplatePromise = EntityTemplatesService.get($routeParams.id);
            } else if ($routeParams.copyEntityTemplateId) {
                loadEntityTemplatePromise = EntityTemplatesService.getCopy($routeParams.copyEntityTemplateId);
            } else {
                loadEntityTemplatePromise = $q.when(newEntityTemplate());
            }

            return loadEntityTemplatePromise
                .then(getEntityTemplateOk, getEntityTemplateError);

            function getEntityTemplateOk(data) {
                vm.entityTemplate = data;
                updateAvailableFields('Search');

                UnsavedChangesService.register({
                    scope: $scope,
                    modelExpression: 'vm.entityTemplate',
                    saveFunction: saveEntityTemplate,
                    unsavedItemName: 'Entity Template'
                });
            }

            function getEntityTemplateError(response) {
                if (response.status === 404) {
                    vm.notFound = true;
                } else {
                    DialogService.error('Error fetching Entity Template', response);
                }
            }
        }

        /**
         * Determine if tab option should be shown.
         *
         * @param {string} tabName - Name of the tab e.g. 'details', 'security'.
         *
         * @returns {bool} Should the tab be shown.
         */
        function showTab(tabName) {
            var result = true;

            if (tabName !== 'details' && vm.loading) {
                result = false;
            } else if (!_.isNil(vm.entityTemplate) && !vm.entityTemplate.Standalone &&
                (tabName === 'security')) {
                result = false;
            } else if ((tabName === 'documentTemplates' || tabName === 'emailTemplates' || tabName === 'smsTemplates') && vm.entityTemplateIsNew) {
                result = false;
            }

            return result;
        }

        /**
         * Update Title to be shown at the top of the view and browser window/tab title.
         */
        function updateViewTitle() {
            var title = 'Entity Template';

            if (!_.isNil($routeParams.id) && $routeParams.id == 'new') {
                title = 'Add ' + title;
            } else if (!_.isNil(vm.entityTemplate) && !_.isNil(vm.entityTemplate.Name) && vm.entityTemplate.Name !== '') {
                title += ' - ' + vm.entityTemplate.Name;
            }

            vm.viewTitle = title;
            WindowTitleService.setTitle(title);
        }

        function addField() {
            DialogService.show({
                controller: 'EntityFieldAddCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/entity-field-add.tmpl.html',
                locals: { entityField: 'new', existingNames: _.map(vm.entityTemplate.Fields, function (field) { return field.Name;}) }
                }).then(addFieldOk);

            function addFieldOk(entityField) {
                vm.entity.Fields = [];

                vm.entityTemplate.Fields.push(entityField);
                updateAvailableFields('Search');

                // Refresh the entity preview fields
                loadDefaultEntityFields();
            }
        }

        /**
         * Present a dialog to let the user add search field(s) to the entity template.
         */
        function addSearchField() {
            FieldSelectorService.displayDialogForEntityTemplate(
                vm.entityTemplate, {
                    multiSelect: true,
                    fieldFormatter: FieldSelectorService.fieldFormatters.simple,
                    selectedFields: vm.entityTemplate.SearchFields,
                    includeEntitySystemForSearch: true,
                    firstLevelFieldsOnly: true
                }).then(selectFieldsOK);

            function selectFieldsOK(selectedFields) {
                vm.entityTemplate.SearchFields = selectedFields;
            }
        }

        /**
         * Remove the specified search field.
         * @param {number} index
         */
        function removeSearchField(index) {
            var searchFieldName = vm.entityTemplate.SearchFields[index];

            DialogService.confirm('Remove the "' + searchFieldName + '" search field?', 'Search Field Remove').then(deleteOk);

            function deleteOk() {
                vm.entityTemplate.SearchFields.splice(index, 1);
            }
        }

        function editField(templateField) {
            DialogService.show({
                locals: { entityField: templateField, existingNames: _.filter(_.map(vm.entityTemplate.Fields, function (field) { return field.Name; }), function (fieldName) { return fieldName != templateField.Name; }) },
                controller: 'EntityFieldAddCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/entity-field-add.tmpl.html'
            })
            .then(editFieldOk);

            function editFieldOk(entityField) {
                vm.entity.Fields = [];

                // Set the values for the entity field to equal those returned from the dialog
                var fieldKeys = Object.keys(entityField);

                angular.forEach(fieldKeys, function (fieldKey) {
                    templateField[fieldKey] = entityField[fieldKey];
                });
                updateAvailableFields('Search');

                // Refresh the entity preview fields
                loadDefaultEntityFields();
            }
        }

        function deleteField(index) {
            DialogService.confirm('Delete the selected field?', 'Field delete confirm')
                .then(deleteOk);

            function deleteOk() {
                vm.entityTemplate.Fields.splice(index, 1);
                updateAvailableFields('Search');
            }
        }

        function addOrderOption() {
            var baseEntityFields = _.filter(vm.entityTemplate.Fields, function (n) { return n.FieldType !== 'Relationship'; });

            DialogService.show({
                locals: { orderOption: 'new', entityFields: baseEntityFields },
                controller: 'OrderOptionAddCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/entitytemplate/order-option-add.tmpl.html'
            })
                .then(addOrderOptionOk);

            function addOrderOptionOk(orderOption) {
                if (orderOption.Default === true || vm.entityTemplate.OrderSetting.Options.length === 0) {
                    vm.entityTemplate.OrderSetting.Default = orderOption.Name;
                }
                delete orderOption.Default;

                vm.entityTemplate.OrderSetting.Options.push(orderOption);
            }
        }

        function editOrderOption(orderOption) {
            var baseEntityFields = _.filter(vm.entityTemplate.Fields, function (n) { return n.FieldType !== 'Relationship'; });

            var orderOptionCopy = angular.copy(orderOption);
            if (vm.entityTemplate.OrderSetting.Default === orderOptionCopy.Name) {
                orderOptionCopy.Default = true;
            }
            else {
                orderOptionCopy.Default = false;
            }

            DialogService.show({
                locals: { orderOption: orderOptionCopy, entityFields: baseEntityFields },
                controller: 'OrderOptionAddCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/entitytemplate/order-option-add.tmpl.html'
            })
            .then(editOrderOptionOk);

            function editOrderOptionOk(updatedOrderOption) {
                if (updatedOrderOption.Default === true) {
                    vm.entityTemplate.OrderSetting.Default = updatedOrderOption.Name;
                }
                else if (vm.entityTemplate.OrderSetting.Default === orderOption.Name) {
                    if (vm.entityTemplate.OrderSetting.Options.length > 1) {
                        vm.entityTemplate.OrderSetting.Default = vm.entityTemplate.OrderSetting.Options[0].Name;
                    }
                }

                delete updatedOrderOption.Default;

                // Set the values for order option to equal the value returned from dialog
                var fieldKeys = Object.keys(updatedOrderOption);

                angular.forEach(fieldKeys, function (fieldKey) {
                    orderOption[fieldKey] = angular.copy(updatedOrderOption[fieldKey]);
                });
            }
        }

        function deleteOrderOption(index) {
            DialogService.confirm('Delete the order option?', 'Order Option delete confirm')
                .then(deleteOk);

            var updateDefault = false;

            function deleteOk() {
                if (vm.entityTemplate.OrderSetting.Options.length < 2) {
                    vm.entityTemplate.OrderSetting.Default = '';
                }
                else if (vm.entityTemplate.OrderSetting.Options[index].Name === vm.entityTemplate.OrderSetting.Default) {
                    updateDefault = true;
                }

                vm.entityTemplate.OrderSetting.Options.splice(index, 1);

                if (updateDefault) {
                    vm.entityTemplate.OrderSetting.Default = vm.entityTemplate.OrderSetting.Options[0].Name;
                }
            }
        }

        function setOrderOptionDefault(orderOption) {
            vm.entityTemplate.OrderSetting.Default = orderOption.Name;
        }

        function newEntityTemplate() {
            return {
                Name: '',
                Description: '',
                Fields: [],
                EntityType: '',
                Active: true,
                Standalone: true,
                ShowOnToolbar: false,
                AccessControl: {
                    GrantAll: true,
                    GrantUsers: [],
                    DenyUsers: []
                },
                OrderSetting: {
                    Default: 'Updated Date',
                    Options: [
                        { Name: 'Updated Date', Fields: [{ Name: 'updated_date', Order: 'desc' }] }
                    ]
                }
            };
        }

        /**
         * Save the entity template
         *
         * @returns {Promise} A promise that resolves once saving is finished.
         */
        function saveEntityTemplate() {
            var promise = null;

            // The icon selector control will set Icon to null if a value has been deselected, this should be set to an empty string instead before sending a save request.
            if (_.isNil(vm.entityTemplate.Icon)) {
                vm.entityTemplate.Icon = '';
            }

            if (!_.isNil(vm.editEntityTemplateForm) && vm.editEntityTemplateForm.$invalid) {
                promise = DialogService.messageList('Error saving entity template', null, vm.editEntityTemplateForm.$error)
                    .then(function () {
                        return $q.reject();
                    });
            } else {
                promise = EntityTemplatesService.save(vm.entityTemplate)
                    .then(saveEntityTemplateOk, saveEntityTemplateError);
            }

            return promise;

            function saveEntityTemplateOk(response) {
                if (vm.entityTemplateIsNew) {
                    UnsavedChangesService.dirty = false;
                    NavigationAidService.replacePage('entitytemplates/' + response);
                } else {
                    vm.entityTemplate = response;
                    vm.editEntityTemplateForm.$setPristine();

                    UnsavedChangesService.register({
                        scope: $scope,
                        modelExpression: 'vm.entityTemplate',
                        saveFunction: saveEntityTemplate,
                        unsavedItemName: 'Entity Template'
                    });

                    updateViewTitle();
                }
            }

            function saveEntityTemplateError(response) {
                return ObjectSaveErrorHandlerService.handleObjectSaveError(
                    response,
                    vm.entityTemplate,
                    'Entity Template',
                    vm.saveEntityTemplate,
                    function () {
                        return EntityTemplatesService.get($routeParams.id);
                    });
            }
        }

        function showUsage() {
            return DialogService.show({
                locals: { entityTemplateIds: [$routeParams.id] },
                controller: 'ShowEntityTemplateUsageDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/entitytemplate/show-entity-template-usage-dialog.tmpl.html'
            });
        }

        function deleteEntityTemplate() {
            if (!vm.entityTemplateIsNew) {
                return DialogService.show({
                    locals: { entityTemplateIds: [$routeParams.id], showCheckbox: false },
                    controller: 'DeleteEntityTemplateDialogCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'app/entitytemplate/delete-entity-template-dialog.tmpl.html'
                }).then(deleteOk);
            } else {
                promptUserToSaveForOperation('deleting');
            }

            function deleteOk() {
                return EntityTemplatesService.deleteTemplate($routeParams.id)
                    .then(deleteEntityTemplateOk)
                    .catch(deleteEntityTemplateError);

                function deleteEntityTemplateOk(success) {
                    NavigationAidService.goBack();
                }

                function deleteEntityTemplateError(response) {
                    DialogService.error('Error deleting Entity Template', response);
                }
            }
        }

        function updateAvailableFields(type) {
            var fieldReference = type + 'Fields';

            if (!angular.isUndefined(vm.entityTemplate) && vm.entityTemplate !== null && !angular.isUndefined(vm.entityTemplate.Fields) && vm.entityTemplate.Fields !== null) {
                if (angular.isUndefined(vm.entityTemplate[fieldReference]) || vm.entityTemplate[fieldReference] === null) {
                    vm.entityTemplate[fieldReference] = [];
                }

                var newAvailableFields = [];
                var fieldsToRemove = [];

                angular.forEach(vm.entityTemplate.Fields, function (field) {
                    if (!angular.isUndefined(field.Visible) && field.Visible) {
                        newAvailableFields.push(field.Name);
                    }
                });

                // Ensure system fields ('$.' prefix) are not removed
                angular.forEach(vm.entityTemplate[fieldReference], function (field) {
                    if (!_.find(newAvailableFields, function (n) { return n === field || field.startsWith('$.'); })) {
                        fieldsToRemove.push(field);
                    }
                    else {
                        _.pull(newAvailableFields, field);
                    }
                });

                angular.forEach(fieldsToRemove, function (field) {
                    _.remove(vm.entityTemplate[fieldReference], function (n) {
                        return n === field;
                    });
                });

                vm.availableFields[type] = angular.copy(newAvailableFields);
            }
        }

        /**
         * Redirects the user to a view with a copy of the current entity template.
         */
        function copyEntityTemplate() {
            if (vm.entityTemplateIsNew) {
                promptUserToSaveForOperation('copying');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges('Entity Template')
                        .then(function () {
                            saveEntityTemplate().then(function () {
                                $location.url('entitytemplates/new?copyEntityTemplateId=' + vm.entityTemplate.Id);
                            });
                        });
                } else {
                    $location.url('entitytemplates/new?copyEntityTemplateId=' + vm.entityTemplate.Id);
                }
            }
        }

        /**
         * Redirects the user to a list view of entities for the entity template.
         */
        function viewEntities() {
            var redirect = false;

            if (vm.entityTemplateIsNew) {
                promptUserToSaveForOperation('viewing entities');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges('Entity Template')
                        .then(function () {

                            saveEntityTemplate().then(function () {
                                redirect = true;
                            });
                        });
                } else {
                    redirect = true;
                }
            }
            if (redirect) {
                var url = '/entities?entityTemplateId=' + vm.entityTemplate.Id;

                if (url === NavigationAidService.getPreviousPath()) {
                    // if the previous path is where you want to go, then simply go back
                    NavigationAidService.goBack();
                }
                else {
                    $location.url(url);
                }
            }
        }

        /**
         * User un-focused the entity template name field.
         */
        function entityTemplateNameBlur() {
            // By default, the plural name for an entity template will be the same as the singular name
            if (_.isNil(vm.entityTemplate.PluralName) || vm.entityTemplate.PluralName === '') {
                vm.entityTemplate.PluralName = vm.entityTemplate.Name;
            }
        }

        /**
         * When the view is 'closed' navigation to a previous page should occur.
         */
        function close() {
            NavigationAidService.goBack();
        }

        /**
         * True if the entity template defers to the "Administrator" setting of users, instead
         * of having its own access control list.
         *
         * @returns {bool}
         */
        function getSecurityDefersToAdmin() {
            if (!_.isNil(vm.entityTemplate) && !_.isNil(vm.entityTemplate.EntityType)) {
                return SystemService.getEntityTypesRequiringAdminAccess().indexOf(vm.entityTemplate.EntityType) != -1;
            } else {
                return false;
            }
        }

        /*
         * When conducting an operation which requires a saved entity template and the entity template is new, a 'save entity template' prompt needs to be shown
         *
         * @param {string} operationName - Name of operation that was being conducted
         */
        function promptUserToSaveForOperation(operationName) {
            return DialogService.show({
                controller: 'SaveItemDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/controls/dialog/save-item-dialog.tmpl.html',
                locals: { name: 'entity template', operation: operationName }
            })
            .then(function () {
                return saveEntityTemplate();
            });
        }

        /**
         * Load all entity templates to the viewmodel. This is needed for the entity preview mode
         *
         * @returns {promise} A promise that resolves once entity templates are loaded.
         */
        function loadEntityTemplates() {
            return EntityTemplatesService.query({ AllowDeleted: true })
                .then(getEntityTemplatesOk, getEntityTemplatesError);

            function getEntityTemplatesOk(data) {
                _.remove(data.EntityTemplates, function (entityTemplate) { return entityTemplate.Active === false; });
                vm.entityTemplates = _.sortBy(data.EntityTemplates, function (entityTemplate) { return entityTemplate.Name; });
            }

            function getEntityTemplatesError(response) {
                DialogService.error('Error fetching Entity Templates', response);
            }
        }

        /**
         * Load all field types to the viewmodel. This is needed for the enityt previe wmode
         *
         * @returns {promise} A promise that resolves once field types are loaded.
         */
        function loadFieldTypes() {
            return FieldTypesService.getFieldTypes()
                .then(getFieldTypesOk, getFieldTypesError);

            function getFieldTypesOk(data) {
                // NB: This is here for drvEntityFieldList, it takes this value from shared scope.
                vm.fieldTypes = data;
            }

            function getFieldTypesError(response) {
                DialogService.error('Error fetching field types', response);
            }
        }

        /**
         * Load default values for the preview entity
         */
        function loadDefaultEntityFields() {
            var entityTemplates = angular.copy(vm.entityTemplates);

            var entityTemplateCopy = angular.copy(vm.entityTemplate);
            entityTemplateCopy.Id = 0;
            entityTemplates.push(entityTemplateCopy);

            vm.entity.Fields = EntityTemplatesService.getDefaultEntityFields(entityTemplates, 0);
            vm.entityPreviewForm.$setPristine();
            vm.entityPreviewForm.$setUntouched();
        }
    }
})();
